import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconSquareComponent } from "./med-icon-square.component";

@NgModule({
  declarations: [
    MedIconSquareComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconSquareComponent,
  ],
})
export class MedIconSquareModule { }
